module.exports = __webpack_public_path__ + "media/store/fonts/BeausiteClassicWeb-Clear-10d3834e0929bc7bd26e69d46bc80ee5.woff2";